import { isTrainingModeEnabled } from '@aloft/toolkit-shared';

import { selectUser } from '../redux/features/selectors/accountSelectors.js';
import { useAppSelector } from '../redux/hooks.js';

export function useIsTrainingModeEnabled(): { isTrainingModeEnabled: boolean } {
  const { email = '' } = useAppSelector(selectUser);

  return {
    isTrainingModeEnabled: isTrainingModeEnabled({ email }),
  };
}
